import React, {useState} from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {IncomingWire, rejectIncomingWire} from "../../resources/incomingWire"
import {
	IncomingWireRejectReason,
	incomingWireRejectReasons,
	isIncomingWireRejectReason,
} from "../../resources/assignments"

interface RejectIncomingWireModalProps {
	incomingWire: IncomingWire
	close: () => void
	onSuccess: () => void
}

function Reason({
	reason,
	setReason,
}: {
	reason: IncomingWireRejectReason
	setReason: (reason: IncomingWireRejectReason) => void
}) {
	return (
		<div className="field">
			<label className="label">Reason</label>
			<div className="select">
				<select
					value={reason}
					onChange={(e) => {
						const {value} = e.target

						if (isIncomingWireRejectReason(value)) {
							setReason(value)
						}
					}}
				>
					{Object.entries(incomingWireRejectReasons).map(([key, {displayName}]) => (
						<option key={key} value={key}>
							{displayName}
						</option>
					))}
				</select>
			</div>
		</div>
	)
}

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function RejectIncomingWireModal({incomingWire, close, onSuccess}: RejectIncomingWireModalProps) {
	const accessToken = useAccessToken()
	const [returnReason, setReturnReason] = useState(IncomingWireRejectReason.NoAccount)
	const [returnReasonText, setReturnReasonText] = useState("")
	const [state, deny] = useAsyncResultIdle(rejectIncomingWire)

	return (
		<AsyncResultModal
			title="Reject Incoming Wire"
			close={refreshAndClose(onSuccess, close)}
			buttonClassname="is-danger"
			state={state}
			buttonText="Reject"
			successText="Rejected"
			onSubmit={() => {
				const wireApiReason = returnReason === IncomingWireRejectReason.NameMismatch ? "NameMissMatch" : returnReason
				deny(accessToken, incomingWire.id, wireApiReason, returnReasonText)
			}}
			errorToText={(err) => err.errors[0].title}
		>
			<div className="field">
				<Reason reason={returnReason} setReason={setReturnReason} />
				<textarea
					className="textarea"
					placeholder="Why are you denying this incoming wire?"
					value={returnReasonText}
					required
					onChange={(e) => setReturnReasonText(e.target.value)}
				/>
			</div>
		</AsyncResultModal>
	)
}
